import styled from "styled-components";
import AddIcon from "../../../assets/img/icons/addicon.svg";
import MinusIcon from "../../../assets/img/icons/minusIcon.svg";
import MenuIcon from "../../../assets/img/icons/nav/Share.svg";
import MoreMenu from "../../../assets/img/CuratedContent/More-Menu.svg";
import { Tooltip } from "antd";
import ShareMenuPopup from "./ShareMenuPopup";
import FavouriteIcon from "../../Common/Components/ArticleFavouriteIcon";
import { useState, useEffect } from "react";
import { openArticleSidebarPreview } from "modules/GlobalActions";
import { getImageUrl, removeOnClickBubble } from "utils";
import { addFavouriteArticle, removeFavoriteArticle } from "../../Content/Favorites/actions";
import { Space } from "antd";
import LargeCheckBox from "modules/Content/Shared/LargeCheckBox";
import store from "store";
import { useSelector } from "react-redux";
import { DRAG_DROP } from "constants/actionTypes";
import { showTooltipPopupFirstTime } from "modules/Login/action";
import CMSPill from "./CMSPill";
import { addArticlesToEmailInEmailBrowser } from "modules/EmailBrowser/actions";
import { getQueryCampaignId, getQueryEmailId } from "modules/EmailBrowser/utils";
import ArticleFavouriteIconTwo from "./ArticleFavouriteIconTwo";
import { DEFAULT_CAMPAIGN_IMAGE } from "constants/types";
import { useLocation } from "react-router-dom";
import CuratedPill from "./CuratedPill";

const BlogItemThree = (props) => {
  const {
    articleId,
    title,
    description,
    website,
    tags,
    publishDate,
    imgUrl,
    isCurated,
    isFav,
    entities,
    link,
    preview,
    isDraggable,
    companyLogo,
    addBlog,
    isCuratedBlog,
    moveCard,
    index,
    isSortable,
    bgWhite,
    noPreview,
    isCMS,
    inEdition,
    selectedBlogItemIndex,
    onBlogItemClick,
    getArticleData,
    inEditionSmartSourced,
    UpdateStatetoRender,
    editionLoading,
    clickedArticleIndex,
    removeReorderIcon,
    companyName,
    categoryColor,
    categoryTitle,
    fullDescription,
    inArticleListContainer,
    hideHighlightedWords,
    inCampaignKeywordExplorer,
    hideCompanyOverlay,
  } = props;

  const location = useLocation();
  const isFavoritesPage =
    location.pathname.includes("favorites") && location.search.includes("email_id") && getQueryEmailId() !== 0;
  const isAccountsPage = location.pathname.includes("myaccounts");
  const selectedArticles = useSelector((state) => state.dragDrop.selectedIds);
  const [isChecked, SetIsChecked] = useState(preview || selectedArticles.includes(articleId) ? true : isDraggable);
  const isTooltipAlreadyShowedFirstTime = useSelector((state) => state.user.isTooltipAlreadyShowedFirstTime);

  const { searchTerms } = useSelector((state) => state.previewArticle);
  const [articleSearchedTerms, setArticleSearchedTerms] = useState([]);
  const [modifiedArticleSearchedTerms, setModifiedArticleSearchedTerms] = useState([]);

  useEffect(() => {
    SetIsChecked(selectedArticles.includes(articleId));
  }, [selectedArticles]);

  const removeFavorite = (e) => {
    e.stopPropagation();
    removeFavoriteArticle(articleId);
  };

  const curateCheckBlog = (e) => {
    store.dispatch({
      type: DRAG_DROP.SET_SELECTED_ID,
      payload: { add: !isChecked, id: articleId },
    });

    if (!isTooltipAlreadyShowedFirstTime) {
      showTooltipPopupFirstTime();
    }
    SetIsChecked(!isChecked);
  };

  const removeSingleArticle = (articleId, index) => {
    if (props.removeSingleArticle) {
      props.removeSingleArticle(articleId, index);
    }
  };

  const addArticleToDraft = (article_id, _articleObj) => {
    const campaignId = getQueryCampaignId();
    const emailId = getQueryEmailId();
    addArticlesToEmailInEmailBrowser(emailId, article_id, campaignId, _articleObj);
  };

  const occurrences = (string, subString, allowOverlapping) => {
    // This function returns the number of a substring repeated in string
    string += "";
    subString += "";
    if (subString.length <= 0) return string.length + 1;
    const stringInLowerCase = string.toLowerCase();
    const subStringInLowerCase = subString.toLowerCase();
    var n = 0,
      pos = 0,
      step = allowOverlapping ? 1 : subString.length;

    while (true) {
      pos = stringInLowerCase.indexOf(subStringInLowerCase, pos);
      if (pos >= 0) {
        ++n;
        pos += step;
      } else break;
    }
    return n;
  };

  useEffect(() => {
    if (searchTerms.length > 0) {
      const searchTermsArray = [];
      searchTerms?.map((term) => {
        const termArray = term.toLowerCase().split(" and ");
        if (termArray.indexOf("and")) {
          termArray.map((subTerm) => {
            if (subTerm !== "and" && !searchTermsArray.includes(subTerm)) {
              searchTermsArray.push(subTerm);
            }
          });
        } else {
          searchTermsArray.push(term);
        }
      });

      setArticleSearchedTerms(searchTermsArray);
    }
  }, [searchTerms]);

  useEffect(() => {
    if (title?.length > 0 && articleSearchedTerms?.length > 0) {
      let modifiedSortedArray = [];
      const helperArray = articleSearchedTerms?.map((tag) => {
        const count = occurrences(title, tag) + occurrences(fullDescription?.replace(/<[^>]*>/g, ""), tag);
        return { tag, count };
      });

      const sortedHelperArray = helperArray.sort((a, b) => {
        return b.count - a.count;
      });

      sortedHelperArray.map((item) => {
        if (item.count > 0) modifiedSortedArray.push(item.tag);
      });

      setModifiedArticleSearchedTerms(modifiedSortedArray.slice(0, 3));
    }
  }, [articleSearchedTerms]);

  return (
    <>
      <BlogItemTwoWrapper id={articleId ? articleId : "CheckBlogItem"} isChecked={isChecked} isPreview={preview}>
        <div
          className={`wrapper ${editionLoading && clickedArticleIndex === index ? "disable" : ""} ${
            isChecked ? "wrapper-checked" : ""
          } ${inEdition && index === selectedBlogItemIndex ? "selected-article" : ""} ${
            props.class === undefined ? "" : props.class
          } ${categoryColor !== undefined ? "" : "not-color-bar"}`}
        >
          <div
            className="devider-color"
            style={{ backgroundColor: categoryColor !== undefined ? categoryColor[0].color : "" }}
          ></div>
          <div
            className="content-div"
            data-article-list="data-article-list"
            onClick={() => {
              if (!noPreview)
                if (!inEdition) {
                  openArticleSidebarPreview(
                    {
                      id: articleId,
                      title,
                      website,
                      tags: entities,
                      entities,
                      publishDate,
                      image_url: imgUrl,
                      imgUrl,
                    },
                    inEdition
                  );
                } else if (selectedBlogItemIndex !== index) {
                  openArticleSidebarPreview(
                    {
                      id: articleId,
                      title,
                      website,
                      tags: entities,
                      entities,
                      publishDate,
                      imgUrl,
                      image_url: imgUrl,
                    },
                    inEdition
                  );
                }
              if (onBlogItemClick) onBlogItemClick(index);
            }}
          >
            {isCuratedBlog === true ? (
              <div className="plus-icon-wrapper">
                <span>
                  <img
                    src={MinusIcon}
                    className="add-icon"
                    alt=""
                    onClick={(e) => {
                      removeSingleArticle(articleId, index);
                      if (!e) var e = window.event;
                      e.cancelBubble = true;
                      if (e.stopPropagation) e.stopPropagation();
                      if (onBlogItemClick) onBlogItemClick(0);
                      getArticleData(0);
                    }}
                  />
                </span>
                {/* </a> */}
              </div>
            ) : null}
            <div className="blog-image">
              <div className="position-relative">
                {!hideCompanyOverlay && (
                  <div
                    className={
                      categoryColor !== undefined ? "company-overlay company-overlay-radius" : "company-overlay"
                    }
                    data-image={DEFAULT_CAMPAIGN_IMAGE}
                    style={{
                      backgroundImage: `url(${
                        imgUrl !== null && imgUrl !== ""
                          ? getImageUrl(imgUrl, 95, 95, articleId)
                          : DEFAULT_CAMPAIGN_IMAGE
                      }), url(${DEFAULT_CAMPAIGN_IMAGE})`,
                    }}
                  ></div>
                )}
                <img
                  src={
                    imgUrl !== null && imgUrl !== ""
                      ? getImageUrl(imgUrl, 95, 95, articleId)
                      : DEFAULT_CAMPAIGN_IMAGE
                  }
                  alt=""
                />
                {companyLogo ? (
                  <div className="company-logo">
                    <img src={companyLogo} />
                  </div>
                ) : (
                  ""
                )}

                {/* adding icons */}
                <div className={`banner-left-icons ${isCuratedBlog ? "cms-alignment" : ""}`}>
                  <Space onClick={(e) => e.stopPropagation()}>
                    {isCuratedBlog === true
                      ? null
                      : props.status !== "Sent" && (
                          <LargeCheckBox
                            isChecked={isChecked || preview}
                            SetIsChecked={(e) => curateCheckBlog(e)}
                            isSmall={preview}
                          />
                        )}
                  </Space>
                  {isCMS && ( // If that article is already added by the user through CMS, My CMS pill will be displayed on the article
                    <div className="cms-pill">
                      <CMSPill textSize="12px" />
                    </div>
                  )}
                </div>

                {/* adding icons end here */}
              </div>
            </div>
            <div className="content padding-right-lg padding-left-md">
              <div className="content-inner-wrapper">
                <h4 className="title">{title}</h4>
                <p className="description margin-top-xs margin-bottom-xs">{description}</p>
              </div>
              <div className="desc">
                <span className="website-link padding-sm">{website}</span>|
                <span className="published-time padding-sm">{publishDate}</span>
                {!window.location.pathname.startsWith("/content/myaccounts") && !hideHighlightedWords && (
                  <>
                    {modifiedArticleSearchedTerms.length > 0 && <>|</>}
                    <span className="published-time padding-sm">
                      {modifiedArticleSearchedTerms?.map((tag, index) => {
                        return (
                          <span key={index} className="green-text-style">
                            {`${index > 0 ? "," : ""} ${tag}`}
                            <span className="black-text-style">{` (${
                              occurrences(title, tag) + occurrences(fullDescription?.replace(/<[^>]*>/g, ""), tag)
                            })`}</span>
                          </span>
                        );
                      })}
                    </span>
                  </>
                )}
                {companyName && (
                  <>
                    |<span className="tags padding-sm"> {companyName}</span>
                  </>
                )}
                {/* <span className="tags padding-sm">{entities}</span> */}
              </div>
            </div>
            {isSortable ? (
              removeReorderIcon ? null : (
                <div className="Blog-menu-icon me-3 ">
                  <Tooltip placement="top" title="Reorder">
                    <a href={undefined}>
                      <img className="hamburger" src={MoreMenu} />
                    </a>
                  </Tooltip>
                </div>
              )
            ) : (
              ""
            )}

            <div className={`title-alignment ${isAccountsPage ? "for-my-account" : ""}`}>
              {categoryTitle !== undefined && (
                <div
                  className="category-title"
                  style={{ backgroundColor: categoryColor !== undefined ? categoryColor[0].color : "" }}
                >
                  {categoryTitle[0].alert}
                </div>
              )}
              <div
                hidden={inCampaignKeywordExplorer}
                style={{ marginTop: inArticleListContainer && !isAccountsPage ? "60%" : "" }}
                className={`d-flex align-items-end ${categoryTitle !== undefined && "has-trigger"}`}
                onClick={(e) => e.stopPropagation()}
              >
                {(inEditionSmartSourced || isFavoritesPage) && isCurated ? (
                  <CuratedPill />
                ) : (
                  (inEditionSmartSourced || isFavoritesPage) && (
                    <div className="add-btn-sent" onClick={removeOnClickBubble}>
                      <a href={undefined}>
                        <img
                          onClick={() =>
                            addArticleToDraft(articleId, {
                              id: articleId,
                              title: title,
                              description: description,
                              image_url: imgUrl,
                              website: website,
                              publish_date: publishDate,
                              is_favourite: isFav,
                              is_curated: isCurated,
                              is_checked: false,
                              entities: entities,
                              link: link,
                            })
                          }
                          src={AddIcon}
                          alt="add icon"
                        />
                      </a>
                    </div>
                  )
                )}
                <span onClick={UpdateStatetoRender}>
                  {isFav ? (
                    <i style={{ cursor: "pointer" }} onClick={(e) => removeFavorite(e)}>
                      <a href={undefined}>
                        <ArticleFavouriteIconTwo />
                      </a>
                    </i>
                  ) : (
                    <i
                      style={{ cursor: "pointer" }}
                      className={"article-fav-icon"}
                      onClick={() => {
                        addFavouriteArticle(articleId, isCurated);
                      }}
                    >
                      <a href={undefined}>
                        <FavouriteIcon />
                      </a>
                    </i>
                  )}
                </span>
                <div
                  className="Blog-menu-icon"
                  onClick={(e) => {
                    if (!e) var e = window.event;
                    e.cancelBubble = true;
                    if (e.stopPropagation) e.stopPropagation();
                  }}
                >
                  <ShareMenuPopup
                    id={props.articleId}
                    // isCurated={props.isCurated}
                    isFav={props.isFav}
                    data={props}
                    // onClick={removeOnClickBubble}
                  >
                    <Tooltip placement="top" title="Share">
                      <a href={undefined}>
                        <img src={MenuIcon} alt="menu" className="padding-sm" />
                      </a>
                    </Tooltip>
                  </ShareMenuPopup>
                </div>
              </div>
            </div>
          </div>
        </div>
      </BlogItemTwoWrapper>
    </>
  );
};
export default BlogItemThree;

BlogItemThree.defaultProps = {
  imgUrl:
    "https://image.freepik.com/free-photo/abstract-surface-textures-white-concrete-stone-wall_74190-8184.jpg",
  title: "Article title goes here and can be up to two lines long if necessary…",
  description:
    "Nulla vitae elit libero, a pharetra augue. Etiam porta sem malesda magna mollis euismod. Nulla vitae elit libero, a pharetra augue.",
  website: "forbes.com",
  published: "2 min ago",
  tags: "Design, Strategy...",
  // categoryColor: "transparent",
  // categoryColor: "#000",
  // categoryTitle: "Products",
};

const BlogItemTwoWrapper = styled.div`
  box-shadow: 0 0 0 4px transparent;
  .green-text-style {
    font-family: "Roboto";
    font-weight: 500;
    color: #27ce0a;
    text-transform: capitalize;
    .black-text-style {
      color: #424b50;
    }
  }
  .disable {
    opacity: 0.5;
    pointer-events: none;
  }
  .selected-article {
    box-shadow: 0 0 0 3px #27ce0a;
  }
  .devider-color {
    width: 8px;
    height: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 2;
    border-radius: 8px 0 0 8px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      height: calc(100% - 0px);
      top: 0;
    }
  }
  .title-alignment {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
  }
  .for-my-account {
    justify-content: space-between;
  }
  .category-title {
    border-radius: 15px;
    color: #ffffff;
    font-weight: 500;
    padding: 2px 10px;
    line-height: 18px;
    height: 22px;
    font-family: "Roboto", sans-serif;
    margin: 3px 3px 0 0;
    white-space: nowrap;
  }
  /* .has-trigger {
    margin-top: 50% !important;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      maring-top: 40%;
    }
  } */
  .cms-pill {
    width: max-content;
    position: absolute;
    /* margin-top: 30px; */
    max-width: 60px;
    top: 8px;
    right: 5px;
    .cms-pill-wrapper {
      padding: 0 7px;
    }
  }
  .wrapper {
    position: relative;
    z-index: 1;
    &.not-color-bar {
      .content-div {
        padding-left: 0;
      }
    }
    &.white-bg {
      background-color: #fff;
      border-radius: 10px;
      margin-bottom: 6px;
      padding: 7px 20px;
    }
    .content-div {
      margin-top: 10px;
      margin-bottom: 10px;
      padding-left: 0px;
      padding-right: 0px;
      display: flex;
      padding-left: 5px;
      margin-left: 0px;
      max-height: 95px;
      overflow: hidden;
      .content {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        flex-grow: 1;
      }
      .plus-icon-wrapper {
        display: flex;
        align-items: center;
        padding-right: 10px;
        img {
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            max-width: 22px;
          }
        }
      }
      .add-icon:hover {
        cursor: pointer;
      }
      .blog-image {
        .position-relative {
          position: relative;
          z-index: 1;
          left: 0px;
          height: 100%;
        }
        position: relative;
        -webkit-align-items: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        display: flex;
        position: relative;
        .banner-left-icons {
          display: flex;
          position: absolute;
          top: 5px;
          left: 7px;
          justify-content: space-between;
          min-width: 110px;
          z-index: 2;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            min-width: 80px;
            left: 15px;
          }
          > div {
            width: 100%;
            justify-content: space-between;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              margin-left: -5px;
            }
            &.cms-pill {
              @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                max-width: 48px;
                margin-top: -3px;
                margin-right: -5px;
                margin-left: auto;
              }
              .cms-pill-wrapper {
                @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                  padding: 0 4px;
                  font-size: 10px;
                }
              }
            }
          }
          img {
            height: 20px;
            width: 20px;
          }
          img.article-fav-icon {
            height: 35px;
            width: 35px;
            margin-top: 0 !important;
            pointer-events: auto;
            -webkit-user-drag: none;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              height: 25px;
              width: 25px;
            }
          }
        }
        .cms-alignment {
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            left: 0;
          }
        }
        .company-logo {
          position: absolute;
          bottom: 0;
          right: 0;
          z-index: 99;
          overflow: hidden;
          img {
            max-width: 40px;
            max-height: 40px;
            border-radius: 0;
          }
        }
        .company-overlay {
          height: 100%;
          width: 115px;
          border-radius: 10px;
          position: absolute;
          left: 0px;
          top: 0px;
          background-size: cover;
          background-color: transparent;
          background-repeat: no-repeat;
          background-position: center;
          z-index: 1;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            width: 81px;
            border-radius: 7px;
          }
          &.company-overlay-radius,
          &.company-overlay-radius + img {
            border-radius: 0 10px 10px 0;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              /* height: 66px; */
              /* height: 100%; */
              width: 81px;
              /* border-radius: 0 7px 7px 0; */
              border-radius: 7px;
            }
          }
        }
        img {
          height: 100%;
          width: 115px;
          border-radius: 10px;
          pointer-events: none;
          min-height: 95px;
          overflow: hidden;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            height: 66px;
            width: 81px;
            min-height: unset;
            border-radius: 7px;
          }
        }
      }
      .title {
        font-family: roboto_slabregular, sans-serif;
        font-size: 22px;
        font-weight: 600;
        color: #424b50;
        margin: 0;
        padding: 0;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 16px;
        }
      }
      .description {
        color: #7e7e7e;
        font-size: 14px;
        font-family: "robotoregular", sans-serif;
        margin-bottom: 0px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 10px;
        }
      }
      .desc {
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        .website-link {
          color: #db3725;
          font-family: "robotomedium", sans-serif;
          font-size: 12px;
          font-weight: 500;
          padding-left: 0;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            font-size: 9px;
          }
        }
        .published-time {
          color: #7e7e7e;
          font-size: 12px;
          font-family: "robotomedium", sans-serif;
          font-weight: 400;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            font-size: 9px;
          }
        }
        .tags {
          color: #27ce0a;
          font-size: 12px;
          font-family: "robotomedium", sans-serif;
          font-weight: 400;
          text-transform: capitalize;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            font-size: 9px;
          }
        }
      }
      div[data-class="curated-article"] {
        position: absolute;
        right: 80px;
        top: auto;
      }
      .add-btn-sent {
        height: 25px;
        width: 25px;
        margin-bottom: 5px;
        position: absolute;
        right: 75px;
        top: auto;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          height: 20px;
          width: 20px;
          margin-bottom: 7px;
        }
        img {
          cursor: pointer;
          height: 20px;
          width: 20px;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            height: 16px;
            width: 16px;
          }
        }
      }
      .Blog-menu-icon {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .Blog-menu-icon img {
        cursor: pointer;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          height: 16px;
          box-sizing: content-box;
        }
        .ant-popover .ant-popover-content .ant-popover-inner {
          border-radius: 10px;
        }
      }
    }
  }

  .campaign-keyword-asider {
    .content-div {
      margin-bottom: 16px;
      padding-bottom: 13px;
      padding-top: 0px;
      border-bottom: 2px solid #e7e7e7;
    }
    .blog-image {
      img {
        width: 80px !important;
        height: 70px !important;
        /* @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          border-radius: 7px;
        } */
      }
    }
    .title {
      font-family: "Roboto Slab", serif;
      font-weight: 600;
      color: #424b50;
      font-size: 22px;
      -webkit-line-clamp: 1 !important;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-word;
    }
    .description {
      display: -webkit-box;
      -webkit-line-clamp: 1 !important;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom: 0px !important;
    }
  }
  .hamburger:hover {
    cursor: grab !important;
  }
  .hamburger:active {
    cursor: grabbing !important;
  }
  .wrapper-checked {
    .content-div {
      border-radius: 8px;
      box-shadow: 0 0 0 4px #27ce0a !important;
    }
  }
  .article-fav-icon {
    margin-bottom: -3px;
    pointer-events: auto;
    -webkit-user-drag: none;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: 28px;
      margin-bottom: 1px;
    }
  }
`;
